import script from "./PhotoRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoRequests.vue?vue&type=script&setup=true&lang=js"

import "./PhotoRequests.vue?vue&type=style&index=0&id=febafda6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-febafda6"]])

export default __exports__